import React from 'react';

import cryptoGift from '@/assets/images/crypto-gift.svg';
import { Avatar } from '../../avatar';
import { Link } from 'react-router-dom';
import { LeaderboardMemberDto } from '@/store/services/MidleNestApi.service';

function LeaderboardUserItem({
  order,
  reward,
  name,
  clan,
  image,
  avgXPPerDay,
  xp,
}: LeaderboardMemberDto & { reward?: number }) {
  return (
    <tr className='text-center'>
      <td className='font-bold w-6 sm:w-8'>{order}</td>
      <td>
        <div className='my-2 lg:md-4 flex items-center text-left'>
          <Avatar name={String(name || name)} src={image} className='h-10 w-10 sm:h-12 sm:w-12 ' />
          <div className='ml-2 sm:ml-4'>
            <span className='whitespace-nowrap truncate'>{name}</span>
            {clan && <span className='block sm:hidden text-gray-400'>{clan}</span>}
          </div>
        </div>
      </td>
      <td className='hidden sm:table-cell'>{avgXPPerDay}</td>
      <td className='hidden sm:table-cell '> {clan ?? '-'}</td>
      <td className=''>{xp ?? 0}</td>
      {reward && (
        <td>
          <div className='flex flex-col items-center justify-end'>
            <img src={cryptoGift} className='w-12 sm:w-16' alt='gift' />
            <div className='text-xs sm:text-sm font-medium'>
              <span className=' font-bold'>{reward}</span> GAMI
            </div>
          </div>
        </td>
      )}
    </tr>
  );
}

function LeaderboardClanItem({
  order,
  reward,
  entityId,
  name,
  members,
  image,
  avgXPPerDay,
  xp,
}: LeaderboardMemberDto & { reward?: number }) {
  return (
    <tr className='text-center'>
      <td className='font-bold w-6 sm:w-8'>{order}</td>
      <td>
        <Link to={'/clans/' + entityId} className='my-2 lg:md-4 flex items-center text-left'>
          <Avatar name={String(name)} src={image} className='h-10 w-10 sm:h-12 sm:w-12 ' />
          <div className='ml-2 sm:ml-4'>
            <span className='whitespace-nowrap truncate'>{name}</span>{' '}
          </div>
        </Link>
      </td>
      <td className='hidden sm:table-cell'>{avgXPPerDay ?? 0}</td>
      <td className='hidden sm:table-cell'>{members ?? 0}</td>
      <td>{xp ?? 0}</td>
      {reward && (
        <td>
          <div className='flex flex-col items-center justify-end'>
            <img src={cryptoGift} className='w-12 sm:w-16' alt='gift' />
            <div className='text-xs sm:text-sm font-medium'>
              <span className=' font-bold'>{reward}</span> GAMI
            </div>
          </div>
        </td>
      )}
    </tr>
  );
}
export default {
  User: LeaderboardUserItem,
  Clan: LeaderboardClanItem,
};
